/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/*-----------------------------------------------------------------------------
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ============================
   FERA INTERNAL TEMPLATE OVERRIDES (REFERENCE COPY)
   ============================ *
   This block is a reference only.
   The LIVE version runs inline in theme.liquid.
   If a theme update overwrites theme.liquid, copy this
   script back into theme.liquid exactly as-is.
*/

const FERA_INTERNAL_OVERRIDE = `
{% if template.suffix == 'fera-internal' %}
<script>
(function() {

  // 1. Remove Real3D modal and any future injections
  function removeReal3D() {
    document.querySelectorAll('.r3d-modal, [id^="r3d-auto-"]').forEach(el => el.remove());
  }

  window.addEventListener('load', removeReal3D);

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (!(node instanceof HTMLElement)) return;

        if (node.classList.contains('r3d-modal') || (node.id && node.id.startsWith('r3d-auto-'))) {
          node.remove();
        }

        node.querySelectorAll('.r3d-modal, [id^="r3d-auto-"]').forEach(el => el.remove());
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // 2. Restore normal product-card click behavior
  document.addEventListener('click', function(e) {
    const card = e.target.closest('.product-card');
    if (!card) return;

    // Real3D hijacks the click by preventing default.
    // We override that by forcing navigation.
    const link = card.querySelector('a.product-card__link');
    if (link) {
      window.location.href = link.href;
    }
  }, true); // capture phase to override Real3D's listener

})();
</script>
{% endif %}
`;
